import api from './api';

const state = {
	admins: [],
	loading: false,
};

const getters = {};

const mutations = {
	startLoading(state) {
		state.loading = true;
	},
	stopLoading(state) {
		state.loading = false;
	},
	setUsers(state, { admins }) {
		admins.forEach((user) => {
			user.initials = user.firstName.substr(0, 2) + user.lastName.substr(0, 1);
		});
		state.admins = admins.sort(function (a, b) {
			return a.lastName.localeCompare(b.lastName);
		});
	},
	showError(state, { message }) {
		state.error = true;
		state.message = message;
	},
};

const actions = {
	load({ state, commit, rootGetters }, showDeleted) {
		commit('startLoading');
		return api
			.list(showDeleted)
			.then((response) => {
				const admins = response.data;
				commit('setUsers', { admins });
				commit('stopLoading');
				return admins;
			})
			.catch((err) => {
				const message = err.data.message;
				commit('showError', { message });
				commit('stopLoading');
			});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
